<template>
    <div class="d-flex align-center flex-column">
        <v-card>
            <s-toolbar
                label="PDF"
                dark
                :color="'#8e8f91'"
                close
                @close="$emit('close')"
                class="mb-6"
            ></s-toolbar>
            <v-card-title style="font-size: small;">
				<v-row>
					<v-col align="right">
						<v-btn 
							fab 	
							x-small
							color="info"
							@click="downloadPdf()"
						>	<v-icon medium>mdi-printer</v-icon>				
						</v-btn>
					</v-col>
				</v-row>
			</v-card-title>
                <hr>
                <vue-html2pdf
                :show-layout="true"
                :float-layout="false"
                :enable-download="false"
                :preview-modal="false"
                :filename="'CONSUMO_INTERNO'"
                :paginate-elements-by-height="1200"
                :pdf-quality="2"
                pdf-format="a4"
                pdf-orientation="portrait"
                pdf-content-width="800px" 
                :manual-pagination="true"
				:margin="1"
                :htmlToPdfOptions="htmlToPdfOptions"
                @progress="onProgress($event)"
                @startPagination="startPagination()"
                @hasPaginated="hasPaginated()"
                @beforeDownload="beforeDownload($event)"
                @hasDownloaded="hasDownloaded($event)" ref="html2Pdf">
                <section slot="pdf-content">
                    <div style="font-family: 'Courier New', Courier, monospace; width: 700px; margin: auto; padding: 20px;">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div>
                            <img src="/static/logo_sp.png" alt="Logo" style="height: 30px;">
                            <div><strong>SUNSHINE EXPORT S.A.C</strong></div>
                            <div style="font-size: 11px;">Car. Tambogrande Las Lomas KM 1077 +179M<br>Tambogrande - Piura</div>
                            </div>
                            <!-- <div style="color: red; font-weight: bold; font-size: 17px;">N°: {{ data.ReqDocumentNumber }}</div> -->
                            <tbody :style="{ fontSize: '10px', backgroundColor: Color_Format }">                 
                                <div style="color: red;background-color: white; font-weight: bold; font-size: 17px;">N°: {{ data.ReqDocumentNumber }}</div>
                                <tr style="border: none;">                                                                    
                                    <td style="border: none;text-align: end;"><span>Código :</span>
                                    </td>
                                    <!-- <td style="border: none;"><span>AP-FR-225</span> -->
                                        <td style="border: none;"><span>
                                            {{Codigo_Format}}
                                            <!-- SIG-CS-AN-FR-019 -->
                                        </span>
                                    </td>
                                </tr>
                                <tr><td style="border: none;text-align: end;">Versión :</td><td style="border: none;">01</td></tr>
                                <tr><td style="border: none;text-align: end;">Fecha de Creación :</td><td style="border: none;">10/09/2025</td></tr>
                                <tr><td style="border: none;text-align: end;">Última Revisión :</td><td style="border: none;">10/09/2025</td></tr>
                                <tr><td style="border: none;text-align: end;">Página :</td><td style="border: none;">1 de 1</td></tr>
                                <tr><td style="border: none;text-align: end;">Anexo :</td><td style="border: none;">00</td></tr>
                            </tbody>
                        </div>

                        <h3 style="text-align: center; margin-top: 10px; font-size: 20px; font-weight: bold;">CONSUMO INTERNO</h3>

                        <div style="display: flex; margin-top: 20px;">
                            <div style="flex: 1;">
                            Fecha: {{ formattedDate }}<br>
                            Usuario: {{ data.UsrName }}
                            </div>
                            <div style="flex: 1;">
                            N° Requerimiento: {{ data.ReqID }}<br>
                            N° Salida: {{ data.DocNumOutput }}
                            </div>
                        </div>

                        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                            <thead>
                                <tr>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">CODIGO</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">CANTIDAD</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">UND.MED</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">DESCRIPCION</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">UBICACIÓN</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">CENTRO COSTO</th>
                                    <!-- <th style="border: 1px solid #000; padding: 5px; text-align: center;">PRECINTO</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(detail, index) in data.Detail" :key="index">
                                    <td style="border: 1px solid #000; padding: 5px; height: 20px; text-align: center;">{{ detail.ArtCode }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.DerQuantity }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.UnitMeasurement }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.DerDescription }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.Location2 }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.CceName }}</td>
                                    <!-- <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.DerCodeSeal }}</td> -->
                                </tr>
                                
                            </tbody>
                        </table>

                        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                            <thead>
                                <tr>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">DESCRIPCION</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">CANTIDAD</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">CODIGO_KIT</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">DESCRIPCION</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">UBICACIÓN</th>
                                    <th style="border: 1px solid #000; padding: 5px; text-align: center;">CENTRO COSTO</th>
                                    <!-- <th style="border: 1px solid #000; padding: 5px; text-align: center;">PRECINTO</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(detail, index) in data.Detail" :key="index">
                                    <td style="border: 1px solid #000; padding: 5px; height: 20px; text-align: center;">{{ detail.ArtCode }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.DerQuantity }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.UnitMeasurement }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.DerDescription }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.Location2 }}</td>
                                    <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.CceName }}</td>
                                    <!-- <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detail.DerCodeSeal }}</td> -->
                                </tr>
                                
                            </tbody>
                        </table>

                        <div style="margin-top: 10px;">
                            Observaciones:
                            <div style="height: 40px;">{{ data.ReqObservation }}</div>
                        </div>

                        <div style="display: flex; justify-content: space-between; margin-top: 40px;">
                            <div style="text-align: center;">
                            ____________________________________<br>
                            POR ALMACÉN<br>FIRMA Y NOMBRE <br> {{ data.RequestDispatchedSAP }}
                            </div>
                            <div style="text-align: center;">
                            ____________________________________<br>
                            RECIBÍ CONFORME<br>FIRMA Y NOMBRE <br> {{ data.RequestCollectedSAP }}
                            </div>
                        </div>
                    </div>
                </section>
                </vue-html2pdf>
        </v-card>
    </div>
</template>

<script>
    import VueHtml2pdf from 'vue-html2pdf'
    import _sReferral from "@/services/Logistics/LgsReferralGuideService.js";
    import qrCode from "vue-qr-generator";
    import _sParameter from "@/services/General/ParameterService.js";

    export default{ 
       
        props:{
            data: {
				type: Object,
				default: null,
			},
        },
        components:{
            VueHtml2pdf,
            qrCode
        },
        data(){
            return{
                urlData: "",
                htmlToPdfOptions: {
                    
                    filename: `CONSUMO_INTERNO.pdf`,
                    jsPDF: {
                    unit: "in",
                    format: "a4",
                    orientation: "portrait",
                    },
                    html2canvas: {
                    useCORS: true,
                    scale: 4,
                    letterRendering: true,
                    },
                },
                Codigo_Format:"SIG-CS-AN-FR-019",
                Color_Format:"white"
            }
        },
        computed:{
            formattedDate() {
                if (!this.data.ReqDate) return '';
                const date = new Date(this.data.ReqDate);
                return date.toLocaleDateString('es-PE').replace(/\//g, '-');
            }
        },
        methods:{ 
            downloadPdf(){
                this.$refs.html2Pdf.generatePdf();
            },
            onProgress(progress) {
				this.progress = progress;
			},
			startPagination() {
			},
			hasPaginated () {
			},

			beforeDownload ({ html2pdf, options, pdfContent }) {
                html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                }).save()
            },
        },
        mounted(){
            //console.log('data', this.data);
        },
        created(){
            _sParameter.search({ PrmName: "CF-INTERNAL-CONSUMPTION"}, this.$fun.getUserID()).then((r) => {
             
              this.Codigo_Format  = r.data.PrmValue ?? 0;
              console.log("codigo",this.Codigo_Format);
            });

             _sParameter.search({ PrmName: "CF-INTERNAL-CONSUMPTION_COLOR"}, this.$fun.getUserID()).then((r) => {
             
              this.Color_Format  = r.data.PrmValue ?? 0;
              console.log("color",this.Color_Format);
            });
        }
    }
</script>